import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusGetInfoPrestacionModalidadSectorial = {
  status: number | null;
  statusText: string | null;
};

const useGetInfoPrestacionModalidadSectorial = () => {
  const [loadingGetInfoPrestacionModalidadSectorial, setLoadingGetInfoPrestacionModalidadSectorial] = useState(false);
  const [successGetInfoPrestacionModalidadSectorial, setSuccessGetInfoPrestacionModalidadSectorial] = useState(false);
  const [errorGetInfoPrestacionModalidadSectorial, setErrorGetInfoPrestacionModalidadSectorial] = useState<any>(null);
  const [dataGetInfoPrestacionModalidadSectorial, setDataGetInfoPrestacionModalidadSectorial] = useState<any>(null);

  const [statusGetInfoPrestacionModalidadSectorial, setStatusGetInfoPrestacionModalidadSectorial] =
    useState<StatusGetInfoPrestacionModalidadSectorial>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  const getInfoPrestacionModalidadSectorial = async (
    userId: string,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetInfoPrestacionModalidadSectorial(true);
    setSuccessGetInfoPrestacionModalidadSectorial(false);
    setErrorGetInfoPrestacionModalidadSectorial(null);

    try {
      const res = await apiRecord.getInfoSolicitudModalidadSectorial(userId);

      setStatusGetInfoPrestacionModalidadSectorial({
        status: res.status,
        statusText: res.statusText
      });

      setSuccessGetInfoPrestacionModalidadSectorial(true);
      setDataGetInfoPrestacionModalidadSectorial(res.data);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetInfoPrestacionModalidadSectorial({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetInfoPrestacionModalidadSectorial(err);
      console.error("Error en getInfoPrestacionModalidadSectorial:", err);

      throw err;

    } finally {
      setLoadingGetInfoPrestacionModalidadSectorial(false);
    }
  };

  return {
    getInfoPrestacionModalidadSectorial,
    loadingGetInfoPrestacionModalidadSectorial,
    successGetInfoPrestacionModalidadSectorial,
    errorGetInfoPrestacionModalidadSectorial,
    dataGetInfoPrestacionModalidadSectorial,
    statusGetInfoPrestacionModalidadSectorial
  };
};

export default useGetInfoPrestacionModalidadSectorial;
